<template>
  <v-dialog v-model="value" max-width="600" persistent scrollable>
    <v-card>
      <v-card-title
        class="d-flex justify-space-between align-center blue white--text py-2">{{ $t('customer.note_form') }}</v-card-title>
      <v-card-text class="mt-2 px-2 py-2">
        <v-text-field v-model="searchMessageTemplate" flat background-color="grey lighten-4" solo :label="$t('search')"
          hide-details></v-text-field>
      </v-card-text>
      <v-card-text class="px-0">
        <v-list v-if="!isLoading" three-line>
          <template v-for="messageTemplate, index in filterMessageTemplate">
            <v-divider :key="'1' + messageTemplate.objectId" v-if="messageTemplate && index == 0"></v-divider>
            <v-list-item :key="`list_${messageTemplate.objectId}`" v-if="messageTemplate" class="list-message">
              <v-list-item-content @click="onSelectMessage(messageTemplate)">
                <v-list-item-title>{{ messageTemplate.topic }}</v-list-item-title>
                <v-list-item-subtitle class="wrap-text">{{ messageTemplate.contented }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-btn icon @click="manageDialog(messageTemplate)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn icon @click="removeDialog(messageTemplate)">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
            <v-divider :key="messageTemplate.objectId" v-if="messageTemplate"></v-divider>
          </template>
        </v-list>
        <div v-if="!isLoading && (messageTemplates && messageTemplates.length == 0)" class="text-center pt-4">
          {{ $t('customer.no_form') }}
        </div>
        <v-card class="justify-center py-7 d-flex" elevation="0" v-if="isLoading">
          <v-progress-circular indeterminate size="40" color="green"></v-progress-circular>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="info" elevation="0" @click="manageDialog()" :disabled="isLoading">
          <v-icon left>mdi-plus</v-icon>{{ $t('customer.add_new') }}
        </v-btn>
        <v-btn color="error" elevation="0" @click="dismiss()" :disabled="isLoading">{{ $t('close') }}</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="isManageDialog" max-width="600" v-if="isManageDialog" scrollable>
      <v-form @submit.prevent="save()" ref="form" :lazy-validation="true" :disabled="isSaveing">
        <v-card>
          <v-card-title
            class="d-flex justify-space-between align-center blue white--text py-2">{{ $t('customer.add_form') }}</v-card-title>
          <v-card-text class="py-5">
            <v-row>
              <v-col cols="12" class="py-1">
                <span>{{ $t('title') }}</span>
                <v-text-field v-model="formData.topic" flat background-color="grey lighten-4" solo :label="$t('title')"
                  :rules="[rules.required]"></v-text-field>
              </v-col>
              <v-col cols="12" class="py-1">
                <span>{{ $t('message') }}</span>
                <span style="float: right; cursor: pointer;" class="blue--text" @click="isAddDataDialog = true">
                  <v-icon small color="blue">mdi-plus</v-icon>{{ $t('add_data') }}
                </span>
                <v-textarea v-model="formData.content" rows="3" flat solo background-color="grey lighten-4"
                  :placeholder="$t('message')" :label="$t('message')" :rules="[rules.required]"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn type="submit" color="success" elevation="0" :disabled="isSaveing">
              <v-icon left>mdi-content-save</v-icon>{{ $t('save') }}
            </v-btn>
            <v-btn color="error" elevation="0" @click="isManageDialog = false" :disabled="isSaveing">{{ $t('close') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="isAddDataDialog" max-width="800" v-if="isAddDataDialog" scrollable>
      <v-card>
        <v-card-title>
          <div class="flex justify-between">
            <div> {{ $t('data') }} </div>
            <v-icon @click="isAddDataDialog = false">mdi-close</v-icon>
          </div>
          <v-tabs v-model="tab">
            <v-tab value="all">{{ $t('all') }}</v-tab>
            <v-tab value="customer">{{ $t('customer.customer_information') }}</v-tab>
            <v-tab value="area-interest">{{ $t('customer.interested_in_business') }}</v-tab>
          </v-tabs>
        </v-card-title>
        <v-card-text>
          <v-tabs-items v-model="tab" class="pt-2">
            <v-tab-item key="all">
              <v-text-field v-model="searchData" flat background-color="grey lighten-4" solo :label="$t('search')"
                hide-details></v-text-field>
              <v-data-table
                :headers="dataTable.headers"
                :items="allInputData"
                :items-per-page="10"
                class="elevation-1 mt-5"
                @click:row="addText"
                :search="searchData"
                :no-data-text="$t('noinfo')"
                :no-results-text="$t('no_matching_records_found')">
              </v-data-table>
            </v-tab-item>
            <v-tab-item key="customer">
              <v-text-field v-model="searchCustomerInputData" flat background-color="grey lighten-4" solo :label="$t('search')"
                hide-details></v-text-field>
              <v-data-table
                :headers="dataTable.headers"
                :items="customerInputData"
                :items-per-page="10"
                class="elevation-1 mt-5"
                @click:row="addText"
                :search="searchCustomerInputData"
                :no-data-text="$t('noinfo')"
                :no-results-text="$t('no_matching_records_found')">
              </v-data-table>
            </v-tab-item>
            <v-tab-item key="area-interest">
              <v-text-field v-model="searchAreaInterestInputData" flat background-color="grey lighten-4" solo
                :label="$t('search')" hide-details></v-text-field>
              <v-data-table
                :headers="dataTable.headers"
                :items="areaInterestInputData"
                :items-per-page="10"
                class="elevation-1 mt-5"
                @click:row="addText"
                :search="searchAreaInterestInputData"
                :no-data-text="$t('noinfo')"
                :no-results-text="$t('no_matching_records_found')">
              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <v-snackbar v-model="isSuccess" color="success" top>
      <v-icon left size="18">mdi-check-circle-outline</v-icon>{{ $t('save_success') }}
    </v-snackbar>
    <v-dialog v-model="isConfirmRemoveDialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="text-h5">
          <h4>
            <v-icon x-large color="error">mdi-alert-outline</v-icon>
            {{ $t('validate.you_want_to_delete_data') }}
          </h4>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="default" @click="onOkRemoveConfirmDialog()" :disabled="isSaveing">{{ $t('confirm') }}</v-btn>
          <v-btn @click="isConfirmRemoveDialog = false" class="error" :disabled="isSaveing">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <ConfirmDialog
      v-if="isConfirmRemoveDialog"
      v-model="isConfirmRemoveDialog"
      title="คุณต้องการลบข้อมูลหรือไม่"
      textBtnOk="ยืนยัน"
      textBtnCancel="ปิด"
      type="error"
      @onOk="onOkRemoveConfirmDialog"
      @onCancel="isConfirmRemoveDialog = false"
    /> -->
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import ConfirmDialog from "@/components/ConfirmDialog.component";
import { ContractTemplate } from "../classes";
export default {
  props: {
    value: Boolean, // v-model from root,
    projectId: String,
    marketId: String,
    areaInterest: Object,
  },
  components: {
    ConfirmDialog
  },
  computed: {
    // ...mapState({
    //   messageTemplates: state => state.messageTemplate.messageTemplates,
    // }),
    filterMessageTemplate() {
      if (this.messageTemplates && this.searchMessageTemplate)
        return this.messageTemplates.filter(word => word.topic.includes(this.searchMessageTemplate))
      else return this.messageTemplates
    },
    // allInputData(){
    //   return [
    //     ...this.customerInputData,
    //     ...this.areaInterestInputData
    //   ]
    // }
  },
  watch: {
    value(value) {
      if (value) {
        this.initData()
        this.resetForm()
      }
    },
  },
  data() {
    return {
      isLoading: false,
      isManageDialog: false,
      isError: false,
      isSuccess: false,
      isSaveing: false,
      isConfirmRemoveDialog: false,
      isAddDataDialog: false,
      tempMessageTemplate: null,
      tab: "all",
      searchMessageTemplate: "",
      searchData: "",
      searchCustomerInputData: "",
      searchAreaInterestInputData: "",
      formData: {
        projectId: this.projectId,
        marketId: this.marketId,
        topic: "",
        content: ""
      },
      rules: {
        required: (value) => !!value || this.$t('validate.please_input_data'),
      },
      dataTable: {
        headers: []
      },
      allInputData: [],
      customerInputData: [],
      areaInterestInputData: [],
      messageTemplates: null
    };
  },
  created() {
    this.customerInputData = this.customerInputData.map(d => {
      return { ...d, value: `{{${d.value}}}` };
    });
    this.areaInterestInputData = this.areaInterestInputData.map(d => {
      return { ...d, value: `{{${d.value}}}` };
    });
    this.allInputData = [
      ...this.customerInputData,
      ...this.areaInterestInputData
    ];

    this.dataTable.headers = [
      {
        text: this.$t('data'),
        align: "center",
        value: "name",
        width: "50%"
      },
      {
        text: "value",
        align: "center",
        value: "value",
        width: "50%"
      }
    ];

    this.customerInputData = [
        {
          name: this.$t('customer.prefix_customer'),
          value: "cusTitle"
        },
        {
          name: this.$t('market.customer_name_and_company_name_not_space'),
          value: "cusFName"
        },
        {
          name: this.$t('customer.postfix_customer'),
          value: "cusLName"
        },
        {
          name: this.$t('customer.age_customer'),
          value: "cusAge"
        },
        {
          name: this.$t('account.citizen_id_card'),
          value: "cusCitizenId"
        },
        {
          name: this.$t('account.issue_date_card'),
          value: "cusCardIssueDate"
        },
        {
          name: this.$t('account.expire_date_card_another_form'),
          value: "cusCardExpDate"
        },
        {
          name: this.$t('customer.address_customer'),
          value: "cusAddress"
        },
        {
          name: this.$t('customer.phone_customer'),
          value: "cusTel"
        },
        {
          name: this.$t('customer.bank_account_customer'),
          value: "cusBanks"
        }
    ];

    this.areaInterestInputData = [
        {
          name: this.$t('contract.start_date'),
          value: "aiSFullDate"
        },
        {
          name: this.$t('contract.end_date'),
          value: "aiEFullDate"
        },
        {
          name: this.$t('area.stall_type'),
          value: "aiConType"
        },
        {
          name: this.$t('area.interested_stall'),
          value: "aiAreasQty"
        },
        {
          name: this.$t('area.space'),
          value: "aiAreas"
        },
        {
          name: this.$t('product.product_in_sell'),
          value: "aiProducts"
        },
        {
          name: this.$t('note'),
          value: "aiNote"
        }
    ];

  },
  methods: {
    async initData() {
      this.isLoading = true
      try {
        this.messageTemplates = await this.$store.dispatch(
          "messageTemplate/getMessageTemplateByProject",
          this.projectId
        );
        for (let messageTemplate of this.messageTemplates) {
          messageTemplate.prepareObjectData({
            areaInterest: this.areaInterest,
            customer: this.areaInterest.customer
          })
        }
        this.isLoading = false
      } catch (error) {
        this.isError = true
        this.isLoading = false
      }
    },
    dismiss() {
      this.$emit("input", false);
    },
    onSelectMessage(messageTemplate) {
      this.$emit("onSelectMessage", messageTemplate.contented || "");
      this.dismiss()
    },
    manageDialog(messageTemplate) {
      if (this.$refs.form) this.$refs.form.resetValidation();
      if (messageTemplate) {
        this.formData = {
          id: messageTemplate.objectId,
          projectId: this.projectId,
          marketId: this.marketId,
          topic: messageTemplate.topic || "",
          content: messageTemplate.content || ""
        };
      } else {
        this.formData = {
          projectId: this.projectId,
          marketId: this.marketId,
          topic: "",
          content: ""
        };
      }
      this.isManageDialog = true
    },
    async save() {
      if (this.$refs.form.validate()) {
        this.isSaveing = true;
        try {
          if (this.formData.id) {
            await this.$store.dispatch(
              "messageTemplate/updateMessageTemplate",
              this.formData
            );
          } else {
            await this.$store.dispatch(
              "messageTemplate/createMessageTemplate",
              this.formData
            );
          }
          this.isSaveing = false;
          this.isManageDialog = false
          this.isSuccess = true
          this.initData()
        } catch (error) {
          this.isSaveing = false;
          this.isManageDialog = false
          this.isError = true
        }
      }
    },
    removeDialog(messageTemplate) {
      this.tempMessageTemplate = messageTemplate
      this.isConfirmRemoveDialog = true
    },
    async onOkRemoveConfirmDialog() {
      this.isSaveing = true
      try {
        await this.$store.dispatch(
          "messageTemplate/removeMessageTemplate",
          this.tempMessageTemplate.objectId
        );
        this.isSaveing = false;
        this.isConfirmRemoveDialog = false
        this.isSuccess = true
        this.initData()
      } catch (error) {
        this.isSaveing = false;
        this.isConfirmRemoveDialog = false
        this.isError = true
      }
    },
    addText(data) {
      this.formData.content += data.value
      this.isAddDataDialog = false
    },
    resetForm() {
      this.tab = "all"
      this.searchMessageTemplate = ""
      this.searchData = ""
      this.searchCustomerInputData = ""
      this.searchAreaInterestInputData = ""
    }
  }
};
</script>

<style scoped>
.list-message:hover {
  background-color: rgba(228, 228, 231);
  cursor: pointer;
}

.wrap-text {
  white-space: normal !important;
  -webkit-line-clamp: unset !important;
}
</style>
